import cx from 'classnames';
import { useI18n } from '../../i18n';
import styles from './SceneTitle.module.css';

type SceneTitleProps = {
  visible: boolean;
  sceneName: string;
  /**
   * Hide the "Journey to {scene}" subtitle while still showing the
   * "Pilgrim" title. Wired from `SceneConfig.disableHud` or
   * `SceneConfig.disableSubtitle` — use on scenes where the scene name
   * itself is not informative to surface (e.g. `overall` root map).
   */
  hideSubtitle?: boolean;
};

export const SceneTitle = ({ visible, sceneName, hideSubtitle }: SceneTitleProps) => {
  const i18n = useI18n();

  return (
    <div className={cx(styles.wrapper, visible && styles.visible)}>
      <h1 className={styles.title}>{i18n.sceneTitle.appName}</h1>
      {!hideSubtitle && (
        <p className={styles.subtitle}>{i18n.sceneTitle.journeyTo(sceneName)}</p>
      )}
    </div>
  );
};
